<template>
  <div>  
      <div class="cx_help_content" >
        <div class="cx_help_content_link cx_campaign" @click="showPopover = !showPopover" ref="target" :tabindex="0">
        <!-- <i class="material-icons small valign" ref="target" >help_outline</i> -->
        <span>サポートセンター</span>  
        </div>
        <b-popover @show="onPopuped" ref="popup"  :target="$refs.target" boundary="window" :placement="left ? 'bottomleft' : 'bottomright'"  v-if="showPopover" :show="showPopover">
            <div class="cx_help_items" :tabindex="0">

                <div class="cx_helpcontent_footer"  :class="{popleft : left}">
                    <div v-if="items && items.length >0"><span>【{{$translate(tag)}}のよくある質問】</span> </div>
                    <div class="cx_helpcontent_pagination" v-if="totalPage > 1">        
                                        
                        <span class="left" :class="{ disabled: pageIndex == 0}" @click="showPage(pageIndex -1)"  id="left"><i class="material-icons small valign">arrow_left</i>戻る</span>              
                        <span class="right" :class="{ disabled: pageIndex == totalPage -1}" @click="showPage(pageIndex +1)"  id="right">次へ<i class="material-icons small valign">arrow_right</i></span>              
                    </div>          
                </div>                                
                <div class="cx_helpcontent_items" :class="{cx_multi_pages : totalPage > 1}" v-if="items && items.length >0">
                    <div class="cx_help_item" v-for="(item, index) in activeItems" :key="index">
                        <span class="cx_link_item" @click="onItemClick(item.id, index)">{{item.description ? item.title + "～" + item.description : item.title}}</span>
                        <span class="cx_help_collection">{{item.collection}}</span>
                    </div>
                </div>
                <div class="cx_helpcontent_header">
                    <div class="cx_helpcontent_search" :class="{cx_has_items : items && items.length >0}">
                        <!-- <div v-if="items && items.length ==0"><span>【サポートセンターの検索】</span> </div>    -->
                        <div class="cx_support_search">
                            <b-form-input class="cx_input_text" v-model="searchWord" placeholder="検索キーワード" size="sm" ></b-form-input>
                            <span class="cx_link_button" @click="moveToSupportCenter">記事検索</span>                                  
                        </div>     
                        <span class="cx_link_item cx_support_center" @click="moveToSupportCenter">サポートセンターに移動</span>
                    </div>
                </div>
            </div>      
        </b-popover>          
        <b-modal v-if="showModal" v-model="showModal" :title="item.title" :no-close-on-backdrop="true" centered ok-only>
            <div class="cx_help_body">
                <h1>{{item.description}}</h1>
                <div v-html="item.body"/>
            </div>
            <!-- 移動ボタンとクローズボタン -->       
            <button slot="modal-footer" type="button" class="btn btn-info" :disabled="currentIndex == 0" @click="move(-1)" ><i class="material-icons small valign">arrow_back</i></button>           
            <button slot="modal-footer" type="button" class="btn btn-info" :disabled="currentIndex == items.length -1" @click="move(1)"><i class="material-icons small valign">arrow_forward</i></button> 
            <button slot="modal-footer" type="button" class="btn btn-success" @click="moveToSupportCenter" >サポートサイトに移動</button>                     
            <button slot="modal-footer" type="button" class="btn btn-primary" @click="showModal = false" >閉じる</button>                           
        </b-modal>               
      </div>    
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class Window extends Vue {
  @Prop({ default: null }) public tag : string; //サポートコンテンツ識別用のタグ
  @Prop({ default: false }) public left : boolean; 
  public showPopover:boolean = false;
  public showModal:boolean = false;
  public  items : Common.HelpContent[] = null;
  public item: Common.HelpContent = null;
  public currentIndex:number = null;
  public searchWord:string = null;

  public created(){
    this.$api.execute(new Common.HelpContentListQuery(this.$translate(this.tag))).then(contents=>{
        this.items = contents;
        this.totalPage = Math.ceil(this.items.length / this.displayCount);
        this.showPage(0);
    });
  }

  public onPopuped(){
      this.searchWord = null;
      this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】ボタン押下');
      this.showPage(0);
    (this.$refs.popup as any)._toolpop.$tip.className += " cx_help_popover";    
    this.$nextTick(()=>{
        var body = ((this.$refs.popup as any)._toolpop.$tip as HTMLElement).getElementsByClassName('cx_help_items')[0] as HTMLElement;
        body.focus();
        body.addEventListener('focusout', this.closePopup);
    });
  }  

  public closePopup(e:any){
      if(e.relatedTarget != null && this.$el.contains(e.relatedTarget as HTMLElement)){
          //閉じてすぐ開く挙動を回避するため、親ボタン側でクローズさせる
      } else if(e.relatedTarget != null && (this.$refs.popup as any)._toolpop.$tip.contains(e.relatedTarget as HTMLElement)){
          //テキスト入力時はスルーする
      } else {
          //v-modelを更新する
          this.showPopover = false;  
      }
  }  

  public onItemClick(id: string, index:number){
    this.currentIndex = index;
    this.showPopover = false;

    this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】個別コンテンツ遷移');

    //直リンクに変更
    window.open('https://support.s-flow.net/ja/articles/' + id, '_blank');

    //カウンターを更新
    this.$api.execute(new Common.HelpContentItemQuery(id));

    // this.$api.startWaitCusor();
    // this.$api.execute(new Common.HelpContentItemQuery(id)).then (res =>{
    //     this.$api.closeWaitCursor();
    //     this.item = res;
    //     this.showModal = true;
    // });
  }

  public move(index:number){
    this.currentIndex += index;
    var id = this.items[this.currentIndex].id;
    this.$api.startWaitCusor();    
    this.$api.execute(new Common.HelpContentItemQuery(id)).then (res =>{
        this.$api.closeWaitCursor();
        this.item = res;
    });      
  }

  
  public pageIndex:number = 0;
  public totalPage:number = 1;
  public activeItems: Common.HelpContent[] = null;
  public displayCount:number = 7;
  public showPage(index: number){
      if (index < 0 || index >= this.totalPage) return;
      this.pageIndex = index;
      this.activeItems = this.items.slice(this.displayCount * this.pageIndex, this.displayCount * (this.pageIndex + 1));
  }

  public moveToSupportCenter(){
    if (this.searchWord) this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】サポートセンター遷移');      
    else  this.$api.issueGA4trackevent(this.$route.path,'【よくあるご質問】サポートセンタートップ');   
    if (this.searchWord) window.open(String.format('https://support.s-flow.net/ja/?q={0}',encodeURI(this.searchWord)), '_blank');
    else window.open('https://support.s-flow.net/ja/', '_blank');
  }
}
</script>

<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_help_content {
    // height: 55px;
    display: flex;
    align-items: center;
    margin-left: 20px;    
    width:120px;
    .cx_campaign{
        font-size: 11px;
        padding: 1px 7px 1px 7px;
        margin : 3px 5px 1px 0px;
        border-radius: 11px;
        height: 22px;
        padding-top:2px;
        font-weight: 600;
        outline: 0 !important;
        box-shadow: none;
        background-color : rgb(248, 122, 4);
        border-color:  rgb(248, 122, 4);
        &:hover{
        background-color : rgb(236, 80, 18);
        border-color:  rgb(236, 80, 18);
        }          
        &:active{
        background-color : rgb(207, 65, 9);
        // outline: 0 !important;
        // box-shadow: none;            
        }
    }    
    .cx_help_content_link {
        overflow-x: hidden;
        overflow-y: hidden;
        //リストメニューに表示
        // height: 24px;                
        color:#fff;
        span{
            margin: 0 2px;
            user-select:none;
        }
        &:hover{
            // color:#be1003;                
            cursor:pointer;
        }      
        >i.small {
            margin-left:2px;
            margin-top:-3px;
            margin-right:0px;
            font-size: 22px;

        }     


    }




    .modal-dialog{
        max-width: 800px;
        .modal-content{
            // width:unset;
            .modal-body{
                width:800px;
                text-align: left;                
            }
        }
    }

    .cx_help_body{
        padding: 20px;
        font-size: 15px;
        height: 500px;
        overflow-y:auto;
        h1 {
            font-size:20px;
            font-weight: 700;
        }        
        h2 {
            font-size:18px;
            font-weight: 700;
        }
        p {
            margin-bottom: 0.3rem;
            min-height: 1.0em;            
        }
    }

}  
.popover.cx_help_popover{
    background-color:#fcf7eb !important;  
    // font-size:12px;
    .popover-body{
        // padding: 5px 8px;
    }
    .arrow::after {
        border-top-color:#fcf7eb !important;  
        border-bottom-color: #fcf7eb !important;        
    }    

    .cx_help_items{
        outline: none;
        box-shadow: none;    
        .cx_multi_pages{
            height: 151px;// height: 107px;
        }
        .cx_help_item{
            margin: 3px 0px 3px 0px;

            height: 19px;
            width:500px;
            white-space:nowrap;
            overflow: hidden;
            text-overflow:ellipsis;

        }
        .cx_help_collection {
            margin-left: 5px;
            color: #a5a5a5;
            font-size: 11px;
        }
       
    }
    .cx_helpcontent_items{
        margin-bottom: 5px;
    }
    .cx_helpcontent_footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cx_link_item{
            margin-top: 2px;
            font-size : 12px;
            color: #6c757d !important;
            &:hover {
                color:  #6c757d !important;          
            }
        }


        // justify-content: start;

        // &.popleft{
        //     justify-content: end;
        // }
    }
    .cx_helpcontent_pagination{
        width : 120px;
        display:flex;
        justify-content: space-between;
        align-items: center;
        // border-top: solid 1px #dbdbdb;  
        // margin-top :10px;
        user-select: none;
        .left{
            margin: 5px 1px 2px 1px;
            color:white;    
            background-color: #6c757d;
            border-color: #6c757d;
            height: 16px;
            border-radius: 2px;    
            padding-right: 7px;
            &:hover:not(.disabled):not(.loading){
                cursor:pointer;
                background-color: #5a6268;
                border-color: #545b62;                  
            }

            &.disabled{  
                opacity: 0.25;   
                cursor:default;      
            }

            i{
                margin-top:-2px;
            }
        }
        span{
            font-size: 11px !important;
            width:auto;
        }

        .right{
            margin: 5px 1px 2px 1px;     
            color:white;
            background-color: #6c757d;
            border-color: #6c757d;    
            height: 16px;
            border-radius: 2px;
            padding-left: 7px;      
            &:hover:not(.disabled):not(.loading){
                cursor:pointer;
                background-color: #5a6268;
                border-color: #545b62;                 
            }
            &.disabled{
                opacity: 0.25; 
                cursor:default;
            }
            i{
                margin-top:-2px;
            }    
        }
    }

    .cx_helpcontent_search{
        display: flex;
        // flex-direction: column;
        align-items: center;
        justify-content: space-between;

        height: 44px;
        min-width:450px;


        &.cx_has_items{
            // border-bottom:1px solid  #dbdbdb;
            // margin-bottom: 10px;
            border-top:1px solid  #dbdbdb;
            margin-top: 10px;  
            padding-top:5px;          
        }
        .cx_support_search{
            display: flex;

            .cx_input_text {
                font-size: 12px;
                width: 200px;
                padding:0 5px;
                height: 24px;
                &:focus{
                    outline: none;
                    box-shadow: unset;                      
                }                
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
            }             
            .cx_link_button{
                margin: 0px 1px 0px 1px;
                color:white;    
                background-color: #6c757d;
                border-color: #6c757d;
                height: 24px;
                vertical-align: middle;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
                padding: 2px 7px;
                font-size: 12px;
                &:hover:not(.disabled):not(.loading){
                    cursor:pointer;
                    background-color: #5a6268;
                    border-color: #545b62;                  
                }            
            }  

        }    
        .cx_support_center{
            margin-right: 5px;
        }            
    }
}    
</style>